import { SITE_URL } from "@shared/env";
import { StateTokenService } from "./StateTokenService";

interface AuthUrlOptions {
  stateToken?: string;
  nextUrl?: string;
  clientId?: string;
  redirectUri?: string;
  scope?: string;
  accessType?: string;
}

export class FacebookOAuthService {
  private static DEFAULT_CLIENT_ID = "1559391937620723";

  private static DEFAULT_REDIRECT_URI = `${SITE_URL}accounts/facebook/login/callback/`;

  private static DEFAULT_SCOPE = encodeURIComponent("email");

  public static AUTH_CHANNEL = "facebook_auth_channel";

  public static MESSAGES = {
    USER_AUTHENTICATED: "UserAuthenticated",
  };

  /**
   * Builds the Facebook OAuth2 URL for authentication.
   *
   * @param {AuthUrlOptions} options - Optional parameters to customize the URL.
   * @returns {string} The constructed OAuth URL.
   */
  static buildAuthUrl(options: AuthUrlOptions = {}): string {
    const stateToken = options.stateToken || StateTokenService.create();
    const nextUrl = options.nextUrl || "/";
    const clientId = options.clientId || this.DEFAULT_CLIENT_ID;
    const redirectUri = options.redirectUri || this.DEFAULT_REDIRECT_URI;
    const scope = options.scope || this.DEFAULT_SCOPE;
    const STATE = encodeURIComponent(
      `stateToken=${stateToken}&nextUrl=${nextUrl}`
    );

    return (
      `https://www.facebook.com/v20.0/dialog/oauth?` +
      `client_id=${clientId}&` +
      `redirect_uri=${redirectUri}&` +
      `scope=${scope}&` +
      `response_type=code%20token&` +
      `return_scopes=false&` +
      `state=${STATE}&`
    );
  }

  /**
   * Verifies the provided state token against the expected HMAC hash.
   * The state token is split into the unique ID and the hash,
   * and the hash is recomputed to check its validity.
   *
   * @param {string} stateToken - The state token to verify.
   * @returns {boolean} True if the token is valid, false otherwise.
   */
  static verifyStateToken(stateToken: string): boolean {
    return StateTokenService.verify(stateToken);
  }
}
